import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { AnswerGroupState } from '@proxy/answer-groups';
import { EnumDescriptor } from '../../enum-descriptor';

@Component({
    selector: 'app-answer-group-state-dropdown',
    templateUrl: './answer-group-state-dropdown.component.html',
    standalone: false
})
export class AnswerGroupStateDropdownComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() selectedAnswerGroupState: AnswerGroupState;

  @Output() changeAnswerGroupState = new EventEmitter<AnswerGroupState>();
  answerGroupStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);

    if (this.isNullOrUndefined(this.selectedAnswerGroupState)) {
      this.selectedAnswerGroupState = AnswerGroupState.Active;
    }
  }

  ngOnInit(): void {
    this.loadAnswerGroupState();
    this.onSelected();
  }

  loadAnswerGroupState(): void {
    this.answerGroupStates = this.getEnumOptions(AnswerGroupState, false);
  }

  onSelected(): void {
    this.changeAnswerGroupState.emit(this.selectedAnswerGroupState);
  }
}
